// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"a532840d","418":"53e2a54e","553":"0acf1d8a","724":"dfec09a4","747":"41c27f0f"}[chunkId] + ".chunk.js";
};